import { get, create, update, remove } from "@/utill/getData";

export function getRoleList() {
  return get("/roles");
}

export function addRole(param) {
  return create("/roles", param);
}

export function updateRole(param) {
  return update(`/roles/${param.roleId}`, param);
}

export function removeRole(roleId) {
  return remove(`/roles/${roleId}`);
}

export function getFunctionsByRole(roleId) {
  return get(`/roles/${roleId}/funcs`);
}

export function saveFunctionsByRole(param) {
  return create(`/roles/funcs`, param);
}
